import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Owners from "@/pages/Owners";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/lib/i18n";
import { MotionConfig } from "framer-motion";

function App() {
  return (
    <MotionConfig reducedMotion="user">
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/wlasciciel" element={<Owners lang="pl" />} />
            <Route path="/owner" element={<Owners lang="en" />} />
            <Route path="/ev-sahibi" element={<Owners lang="tr" />} />
            <Route path="/ev-sahibi-az" element={<Owners lang="az" />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" />
      </div>
    </LanguageProvider>
    </MotionConfig>
  );
}

export default App;
